import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { classNames } from 'utils/classNames';

import Sidebar from './subcomponents/Sidebar';
import Topbar from './subcomponents/Topbar';
import Content from './subcomponents/Content';
import Preview from './subcomponents/Preview';
import LoaderOverlay from './subcomponents/LoaderOverlay';
import FullScreenTransition from './subcomponents/FullScreenTransition';

const BASE_CLASS_NAME = 'Workspace';

export default class Workspace extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: null,
    };

    static Sidebar = Sidebar;

    static Topbar = Topbar;

    static Content = Content;

    static Preview = Preview;

    static LoaderOverlay = LoaderOverlay;

    static FullScreenTransition = FullScreenTransition;

    checkIfWorkspaceHasSidebar() {
        let hasSidebar = false;

        React.Children.forEach(this.props.children, (child) => {
            if (child && child.type === Sidebar) {
                hasSidebar = true;
            }
        });

        return hasSidebar;
    }

    render() {
        const hasSidebar = this.checkIfWorkspaceHasSidebar();
        const className = classNames({
            [BASE_CLASS_NAME]: true,
            [`${BASE_CLASS_NAME}--has-sidebar`]: hasSidebar,
            [this.props.className]: this.props.className,
        });

        return <div className={className}>{this.props.children}</div>;
    }
}
